import { render, staticRenderFns } from "./top4.vue?vue&type=template&id=4c520660&scoped=true"
import script from "./top4.vue?vue&type=script&lang=js"
export * from "./top4.vue?vue&type=script&lang=js"
import style0 from "./top4.vue?vue&type=style&index=0&id=4c520660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c520660",
  null
  
)

export default component.exports